import axios from "axios";
import CryptoJS from "crypto-js";


export const getUserIP = async () => {
    try {
        const response = await axios.get('https://api.ipify.org?format=json');
        return response.data.ip;
    } catch (error) {
        console.error('Error fetching IP address:', error);
        return null;
    }
};

// Helper functions to get device and location data
export const getUserLocation = () => {
    return new Promise((resolve) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        lat: Number(position.coords.latitude.toFixed(7)), // 7 decimal places
                        long: Number(position.coords.longitude.toFixed(7)), // 7 decimal places
                    });
                },
                (error) => {
                    console.error("Error retrieving location:", error.message);

                    let errorMessage = "Unknown error";
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = "User denied the request for Geolocation.";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = "Location information is unavailable.";
                            break;
                        case error.TIMEOUT:
                            errorMessage = "The request to get user location timed out.";
                            break;
                        case error.UNKNOWN_ERROR:
                            errorMessage = "An unknown error occurred.";
                            break;
                    }

                    console.warn("Geolocation Error:", errorMessage);

                    resolve({
                        lat: 0,
                        long: 0,
                        error: errorMessage, // Return error message for debugging
                    });
                },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 } // Adjust settings
            );
        } else {
            console.warn("Geolocation is not supported by this browser.");
            resolve({
                lat: 0,
                long: 0,
                error: "Geolocation is not supported",
            });
        }
    });
};


export const getDeviceDetails = () => {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown";
    let browserVersion = "Unknown Version";
    let deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    let deviceOS = "Unknown";
    let deviceOSVersion = "Unknown OS Version";
    let renderingEngine = "Unknown";

    // Detect OS and OS version
    if (/Windows NT 10.0/i.test(userAgent)) {
        deviceOS = "Windows";
        deviceOSVersion = "10";
    } else if (/Windows NT 6.3/i.test(userAgent)) {
        deviceOS = "Windows";
        deviceOSVersion = "8.1";
    } else if (/Windows NT 6.2/i.test(userAgent)) {
        deviceOS = "Windows";
        deviceOSVersion = "8";
    } else if (/Windows NT 6.1/i.test(userAgent)) {
        deviceOS = "Windows";
        deviceOSVersion = "7";
    } else if (/Mac OS X (\d+_\d+)/i.test(userAgent)) {
        deviceOS = "macOS";
        deviceOSVersion = userAgent.match(/Mac OS X (\d+_\d+)/i)[1].replace("_", ".");
    } else if (/Android (\d+\.\d+)/i.test(userAgent)) {
        deviceOS = "Android";
        deviceOSVersion = userAgent.match(/Android (\d+\.\d+)/i)[1];
    } else if (/iPhone OS (\d+_\d+)/i.test(userAgent)) {
        deviceOS = "iOS";
        deviceOSVersion = userAgent.match(/iPhone OS (\d+_\d+)/i)[1].replace("_", ".");
    }

    // Detect browser and version
    if (/Edg\/(\d+\.\d+)/i.test(userAgent)) {
        browserName = "Microsoft Edge";
        browserVersion = userAgent.match(/Edg\/(\d+\.\d+)/i)[1];
        renderingEngine = "Blink";
    } else if (/Chrome\/(\d+\.\d+)/i.test(userAgent)) {
        browserName = "Google Chrome";
        browserVersion = userAgent.match(/Chrome\/(\d+\.\d+)/i)[1];
        renderingEngine = "Blink";
    } else if (/Firefox\/(\d+\.\d+)/i.test(userAgent)) {
        browserName = "Mozilla Firefox";
        browserVersion = userAgent.match(/Firefox\/(\d+\.\d+)/i)[1];
        renderingEngine = "Gecko";
    } else if (/Safari\/(\d+\.\d+)/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
        browserName = "Safari";
        browserVersion = userAgent.match(/Version\/(\d+\.\d+)/i)[1];
        renderingEngine = "WebKit";
    } else if (/MSIE (\d+\.\d+)/i.test(userAgent)) {
        browserName = "Internet Explorer";
        browserVersion = userAgent.match(/MSIE (\d+\.\d+)/i)[1];
        renderingEngine = "Trident";
    } else if (/Trident.*rv:(\d+\.\d+)/i.test(userAgent)) {
        browserName = "Internet Explorer";
        browserVersion = userAgent.match(/Trident.*rv:(\d+\.\d+)/i)[1];
        renderingEngine = "Trident";
    }

    return {
        deviceType,
        deviceOS,
        deviceOSVersion,
        browserName,
        browserVersion,
        renderingEngine,
        browserUserAgent: userAgent,
    };
};



export const generateDeviceSignature = (data) => {
    return CryptoJS.SHA256(JSON.stringify(data)).toString();
};
